import React from 'react';
import { Button } from 'antd-mobile';
import { inApp } from '@hst/utils';
import { useLocation } from 'react-router-dom';
import { jumpPathPageByWindow, commonH5Jump, jumpTransferPage } from 'src/utils/jump';
import { trackActivityPageClick, trackfixedButtonClick } from 'src/pages/marketing/track';
import { useTranslation } from 'react-i18next';
import './index.less';

interface propsType {
	data: {
		backgroundImg: string; // 背景图片
		backGroundColor: string; //背景颜色
		btnName?: string; // 按钮名称
		btnText?: string; // 按钮文案
		textColor?: string; // 字体颜色
		jumpLink?: number; // 跳转类型 1 下载/唤起APP 2 H5链接 3 原生链接
		jumpLinkStr?: string; // 原生跳转LINK
		jumpPosition?: string; // H5跳转链接
		jumpParam?: string; // 原生跳转参数
		jumpLinkStrNew?: string; // 新的原生跳转LINK
		jumpParamNew?: string; // 新的原生跳转参数
	};
	pageStatus: string;
	compType: string;
	compId: string;
}

export default (props: propsType) => {
	const { data, pageStatus = 'normal', compType = 'base_btn', compId } = props;
	const {
		backgroundImg,
		backGroundColor,
		btnName,
		btnText,
		textColor,
		jumpLink,
		jumpLinkStr,
		jumpPosition,
		jumpParam,
		jumpLinkStrNew,
		jumpParamNew,
	} = data;
	const searchParams = new URLSearchParams(useLocation().search);
	const { i18n } = useTranslation();
	const lang = i18n.language;

	const btnClick = () => {
		const _scnl = searchParams.get('_scnl') || '';
		const pageId = searchParams.get('id') || '';

		if (pageStatus !== 'normal') {
			return;
		}
		if (compType === 'fixed_btn') {
			trackfixedButtonClick(pageId);
		} else {
			trackActivityPageClick(pageId, btnName, compId);
		}

		// 1 下载/唤起APP 2 H5链接 3 原生链接 4 新版原生链接
		switch (jumpLink) {
			case 1:
				if (!inApp()) {
					jumpTransferPage(lang, {
						redirectType: '1',
						redirectValue: { _scnl },
					});
				}
				break;
			case 2:
				jumpPathPageByWindow(jumpPosition, { _scnl });
				break;
			case 3:
				commonH5Jump(jumpLinkStr, { ...JSON.parse(jumpParam), _scnl }, lang);
				break;
			case 4:
				commonH5Jump(jumpLinkStrNew, { ...JSON.parse(jumpParamNew), _scnl }, lang);
				break;
			default:
				break;
		}
	};

	return (
		<>
			{backgroundImg ? (
				<div className='co-btn-img' style={{ backgroundColor: backGroundColor }} onClick={btnClick}>
					<img src={backgroundImg} alt='img' />
				</div>
			) : (
				<Button
					style={{ color: textColor, backgroundColor: backGroundColor }}
					block
					shape='rounded'
					color='primary'
					onClick={btnClick}>
					{btnText}
				</Button>
			)}
		</>
	);
};
